import { CSSProperties, ReactNode } from "react";

type Tone = "default" | "primary" | "success" | "warning" | "danger" | "muted";

interface BadgeProps {
  children: ReactNode;
  tone?: Tone;
  className?: string;
  style?: CSSProperties;
}

const toneMap: Record<Tone, string> = {
  default: "bg-surface text-text-secondary dark:bg-surface-hover",
  primary: "bg-primary-subtle text-primary",
  success: "bg-success-subtle text-success",
  warning: "bg-warning-subtle text-warning",
  danger: "bg-danger-subtle text-danger",
  muted: "bg-bg-elevated text-text-muted",
};

export function Badge({ children, tone = "default", className = "", style }: BadgeProps) {
  return <span className={`badge ${toneMap[tone]} ${className}`} style={style}>{children}</span>;
}
